import { render } from "./DashboardingEmpty.vue?vue&type=template&id=67be6f39&lang=pug"
import script from "./DashboardingEmpty.vue?vue&type=script&lang=js"
export * from "./DashboardingEmpty.vue?vue&type=script&lang=js"

import "./DashboardingEmpty.vue?vue&type=style&index=0&id=67be6f39&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__